import React from 'react';
import { Plus } from 'lucide-react';
import { RecipeList } from '../components/RecipeList';
import { useRecipeStore } from '../store/recipeStore';
import { ErrorBoundary } from '../components/ErrorBoundary';

interface RecipesPageProps {
  onImport: () => void;
}

export function RecipesPage({ onImport }: RecipesPageProps) {
  const { fetchRecipes } = useRecipeStore();

  React.useEffect(() => {
    fetchRecipes();
  }, [fetchRecipes]);

  return (
    <div className="space-y-8">
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">Your Recipes</h2>
          <button
            onClick={onImport}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
          >
            <Plus size={20} />
            Import Recipe
          </button>
        </div>
        <ErrorBoundary>
          <RecipeList />
        </ErrorBoundary>
      </div>
    </div>
  );
}